module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en-us":{"attachFileModalContent":{"generalError":"Sorry, something went wrong. Please try again. Your file type may not be supported","fileSizeError":"Your attachment is too large. It must be under 10MB.","title":"Attach a file"}}}')
  delete Component.options._Ctor
}
